import React from "react";
import PropTypes from "prop-types";
import IntranetHeader from "../../components/intranet/IntranetHeader";
import IntranetNavBar from "../../components/intranet/IntranetNavBar";
import MobxPageContent from "shared/components/MobxPageContent";
import { observer } from "mobx-react";

@observer
class IntranetPageContent extends React.Component {
    static propTypes = {
        selectedHeaderItem: PropTypes.string,
        className: PropTypes.string
    }

    render() {
        const header = <IntranetHeader />;
        const navigation = <IntranetNavBar selected={this.props.selectedHeaderItem} />;
        const footer = <div />;

        return (
            <MobxPageContent header={header} navigation={navigation} footer={footer} className={this.props.className}>
                {this.props.children}
            </MobxPageContent>
        );
    }
}

export default IntranetPageContent;
